<template>
  <div class="jspg-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌">
              <el-select v-model="searchForm.brandId" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option v-for="brand in brandList" :key="brand.brand_id" :label="brand.brand_name" :value="brand.brand_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
              <el-button icon="el-icon-printer" @click="exportAllExcel">导出全部驳回订单</el-button>
              <el-button icon="el-icon-view" @click="seeBhOrders">查看驳回订单</el-button>
              <el-button icon="el-icon-data-analysis" @click="seeBhOrdersAnalysis">驳回订单统计</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="140"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="130"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单性质"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.nature===0">家装</span>
                      <span v-if="scope.row.nature===1">展厅</span>
                      <span v-if="scope.row.nature===2">工程</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="品牌"
                    width="140"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.brand_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="接单时间"
                    width="180"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.receive_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===4" type="warning">待评估</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-document" @click.stop="assess(scope.row)">立即评估</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="技术评估"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules"  label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="评估备注" prop="content">
          <!-- <el-input type="textarea" v-model="editForm.content" maxlength="200" show-word-limit></el-input> -->
          <el-select
            style="width: 100%;"
            v-model="editForm.content"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请选择或输入备注/原因">
            <el-option
              v-for="(item, index) in rsonList"
              :key="index"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile v-model="editForm.files"></MultiFile>
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg v-model="editForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" icon="el-icon-check" :loading="editloading" @click="subEdit('editForm')">评估通过</el-button>
          <el-button type="danger" icon="el-icon-close" :loading="editloading" @click="turn('editForm')">驳回</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :title="orderViewTitle" :visible.sync="orderVisible" width="85%" top="10vh"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true">
      <div style="padding:10px 20px" v-loading="orderLoading">
        <el-form :inline="true" size="small" :model="orderSearchForm" @submit.native.prevent>
          <el-form-item label="订单类型">
            <el-select v-model="orderSearchForm.orderType" style="width: 120px" filterable clearable>
              <el-option-group label="">
                <el-option label="正单" :value="'0'" />
                <el-option label="补单" :value="5" />
              </el-option-group>
              <el-option-group label="补单类型">
                <el-option label="客改单" :value="1" />
                <el-option label="增补单" :value="2" />
                <el-option label="色板单" :value="3" />
                <el-option label="售后单" :value="4" />
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="品牌">
            <el-select v-model="orderSearchForm.bid" style="width: 120px" filterable clearable>
              <el-option v-for="brand in brandList" :key="brand.brand_id" :label="brand.brand_name" :value="brand.brand_id" />
            </el-select>
          </el-form-item>
          <el-form-item label="驳回时间">
            <el-date-picker v-model="orderSearchForm.time" style="width: 300px" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" type="daterange"
              clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="搜索关键字">
            <el-input v-model="orderSearchForm.content" style="width: 200px" placeholder="关键字搜索" @keyup.enter.native="seeBhOrders"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" @click="seeBhOrders">搜索</el-button>
            <el-button icon="el-icon-printer" @click="exportExcel(orderSearchForm)">导出驳回订单</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="orderList"
          size="small"
          style="width: 100%;border:1px solid #EBEEF5;"
          height="500">
          <el-table-column
            label="订单号"
            width="120"
            align="center"
            fixed
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: 500;color:#409EFF">{{scope.row.orderNum}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="订单类型"
            width="80"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.orderType===0">正单</span>
              <span v-if="scope.row.orderType===1">客改单</span>
              <span v-if="scope.row.orderType===2">增补单</span>
              <span v-if="scope.row.orderType===3">色板单</span>
              <span v-if="scope.row.orderType===4">售后单</span>
            </template>
          </el-table-column>
          <el-table-column
            label="品牌"
            width="80"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ brandList.find(r => r.brand_id === scope.row.bid).brand_name || '' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="经销商"
            width="130"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span :style="scope.row.dealerName && scope.row.dealerName.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                {{ scope.row.dealerName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="经销商电话"
            width="110"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.dealerTel }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="详细地址"
            min-width="200"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.address}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="经办人"
            width="100"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.username }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="驳回原因"
            min-width="200"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.content}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="驳回时间"
            align="center"
            min-width="160">
            <template slot-scope="scope">
              <span>{{scope.row.time}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px;"
          v-if="orderTotal>0"
          background
          @size-change="handleBhOrderSizeChange"
          @current-change="handleBhOrderCurrentChange"
          :current-page="orderCurrentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="orderPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="orderTotal">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog title="技术驳回订单统计" :visible.sync="orderAnalysisVisible" width="85%" top="10vh"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true">
      <div style="padding:10px 20px" v-loading="orderAnalysisLoading">
        <div class="card-content">
          <el-form :inline="true" size="small" :model="orderAnalysisSearchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="orderAnalysisSearchForm.orderType" style="width: 120px" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="'0'" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌">
              <el-select v-model="orderAnalysisSearchForm.bid" style="width: 120px" filterable clearable>
                <el-option v-for="brand in brandList" :key="brand.brand_id" :label="brand.brand_name" :value="brand.brand_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="驳回时间">
              <el-date-picker v-model="orderAnalysisSearchForm.time" style="width: 300px" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" type="daterange"
                clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="orderAnalysisSearchForm.content" style="width: 200px" placeholder="关键字搜索" @keyup.enter.native="seeBhOrdersAnalysis"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="seeBhOrdersAnalysis">搜索</el-button>
              <el-button icon="el-icon-printer" @click="exportExcel(orderAnalysisSearchForm)">导出驳回订单</el-button>
            </el-form-item>
          </el-form>
          <el-row :gutter="20">
            <el-col :span="24">
              <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                驳回原因统计：共 {{ orderAnalysisData.globalTotalCount || 0 }} 条
              </div>
            </el-col>
            <el-col :span="12" style="padding-top: 10px">
              <el-table :data="orderAnalysisData.totalReasonCountList" stripe style="width: 100%">
                <el-table-column prop="name" label="驳回原因" align="center" width="200" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="total" align="center" label="订单数量">
                  <template slot-scope="scope">
                    <span style="font-weight: 500;color:#409EFF">{{ scope.row.total }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="数量占比">
                  <template slot-scope="scope">
                    <span>{{ scope.row.scaleTotal }}%</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="130" fixed="right">
                  <template slot-scope="scope">
                    <el-button size="mini" icon="el-icon-view" @click="seeAnalysisDetail(scope.row)">查看详情</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="12" v-if="chartOption.totalReasonCount">
              <GraphicsChart id="totalReasonCount" :option="chartOption.totalReasonCount" />
            </el-col>
            <!-- <el-col :span="24" style="padding-top: 10px">
              <el-table :data="orderAnalysisData.dealerReasonCountList" stripe style="width: 100%">
                <el-table-column prop="name" label="经销商" align="center" width="150" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="total" align="center" label="总驳回订单数">
                  <template slot-scope="scope">
                    <span style="font-weight: 500;color:#409EFF">{{ scope.row.total }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col> -->
            <el-col :span="24" v-if="chartOption.dealerTotalCount">
              <GraphicsChart id="dealerTotalCount" :option="chartOption.dealerTotalCount" />
            </el-col>
            <el-col :span="24" v-if="chartOption.dealerReasonCount">
              <GraphicsChart id="dealerReasonCount" :option="chartOption.dealerReasonCount" />
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="orderAnalysisDetailViewTitle" :visible.sync="orderAnalysisDetailVisible" width="80%" top="15vh"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true">
      <div style="padding:10px 20px" v-loading="orderAnalysisDetailLoading">
        <el-table
          :data="orderAnalysisDetailList"
          size="small"
          style="width: 100%;border:1px solid #EBEEF5;"
          height="500">
          <el-table-column
            label="订单号"
            width="120"
            align="center"
            fixed
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: 500;color:#409EFF">{{scope.row.orderNum}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="订单类型"
            width="80"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.orderType===0">正单</span>
              <span v-if="scope.row.orderType===1">客改单</span>
              <span v-if="scope.row.orderType===2">增补单</span>
              <span v-if="scope.row.orderType===3">色板单</span>
              <span v-if="scope.row.orderType===4">售后单</span>
            </template>
          </el-table-column>
          <el-table-column
            label="品牌"
            width="80"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ brandList.find(r => r.brand_id === scope.row.bid).brand_name || '' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="经销商"
            width="130"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span :style="scope.row.dealerName && scope.row.dealerName.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                {{ scope.row.dealerName }}
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="经销商电话"
            width="110"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.dealerTel }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            label="详细地址"
            min-width="200"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.address}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="经办人"
            width="100"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.username }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="驳回原因"
            min-width="200"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.content}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="驳回时间"
            align="center"
            min-width="160">
            <template slot-scope="scope">
              <span>{{scope.row.time}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getOrderList, assessOrder, getBhRsonList, exportOrderJsbh, getOrderJsbh, getOrderJsbhAnalysis, getOrderJsbhAnalysisDetail } from '@/api/erp'
import { getBrandList } from '@/api/work'
import MultiFile from '@/components/upload/MultiFile'
import MultiImg from '@/components/upload/MultiImg'
import GraphicsChart from '@/components/Charts/GraphicsChart'

export default {
  name: 'jspg',
  computed: {
    user: getUser
  },
  components: {
    MultiFile,
    MultiImg,
    GraphicsChart
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editloading: false,
      editForm: {
        orderid: '',
        ordername: '',
        content: '',
        files: [],
        imgids: []
      },
      editRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: false, message: '请在这里填写驳回原因', trigger: 'change' }]
      },
      searchForm: {
        search: '',
        type: '',
        brandId: ''
      },
      brandList: [],
      rsonList: [],

      orderViewTitle: '',
      orderSearchForm: {
        content: '',
        orderType: '',
        bid: '',
        time: []
      },
      orderLoading: false,
      orderVisible: false,
      orderList: [],
      orderCurrentPage: 1,
      orderPageSize: 20,
      orderTotal: 0,

      orderAnalysisSearchForm: {
        content: '',
        orderType: '',
        bid: '',
        time: []
      },
      orderAnalysisVisible: false,
      orderAnalysisLoading: false,
      orderAnalysisData: {},
      chartOption: {},

      orderAnalysisDetailViewTitle: '',
      orderAnalysisDetailVisible: false,
      orderAnalysisDetailLoading: false,
      orderAnalysisDetailList: [],
    }
  },
  created() {
    this.getData()
    this.getBrandList()

    const myDate = new Date()
    const year = myDate.getFullYear()
    let month = myDate.getMonth() + 1
    let day = myDate.getDate()
    month = month > 9 ? month + '' : '0' + month
    day = day > 9 ? day + '' : '0' + day

    this.orderSearchForm.time.push(year + '-' + month + '-01')
    this.orderSearchForm.time.push(year + '-' + month + '-' + day)

    this.orderAnalysisSearchForm.time.push(year + '-' + month + '-01')
    this.orderAnalysisSearchForm.time.push(year + '-' + month + '-' + day)

  },
  methods: {
    getBrandList() {
      getBrandList().then(response => {
        this.brandList = response.data
      })
    },
    Search() {
      this.currentPage = 1
      this.searchForm.search = this.searchForm.search.trim()
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        mark: 4,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        type: this.searchForm.type,
        brandId: this.searchForm.brandId
      }
      getOrderList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },

    seeBhOrders() {
      this.orderVisible = true
      this.orderTotal = 0
      this.orderCurrentPage = 1
      this.getBhOrders()
    },
    getBhOrders() {
      let startTime = null
      let endTime = null
      if (this.orderSearchForm.time !== null && this.orderSearchForm.time.length === 2) {
        startTime = this.orderSearchForm.time[0]
        endTime = this.orderSearchForm.time[1]
      }
      const data = {
        page: this.orderCurrentPage,
        limit: this.orderPageSize,
        start: startTime,
        end: endTime,
        content: this.orderSearchForm.content ? this.orderSearchForm.content : null,
        orderType: this.orderSearchForm.orderType ? this.orderSearchForm.orderType : null,
        bid: this.orderSearchForm.bid ? this.orderSearchForm.bid : null
      }
      this.orderLoading = true
      getOrderJsbh(data).then(response => {
        this.orderList = response.data || []
        this.orderLoading = false
        this.orderTotal = response.total || 0
        this.orderViewTitle = '已驳回订单 (共 ' + this.orderTotal + ' 单)'
      }).catch(() => {
        this.orderLoading = false
      })
    },
    handleBhOrderSizeChange(val) {
      this.orderPageSize = val
      this.getBhOrders()
    },
    handleBhOrderCurrentChange(val) {
      this.orderCurrentPage = val
      this.getBhOrders()
    },

    seeAnalysisDetail(row) {
      this.orderAnalysisDetailVisible = true

      let startTime = null
      let endTime = null
      if (this.orderAnalysisSearchForm.time !== null && this.orderAnalysisSearchForm.time.length === 2) {
        startTime = this.orderAnalysisSearchForm.time[0]
        endTime = this.orderAnalysisSearchForm.time[1]
      }
      const data = {
        start: startTime,
        end: endTime,
        content: row.name || null,
        orderType: this.orderAnalysisSearchForm.orderType ? this.orderAnalysisSearchForm.orderType : null,
        bid: this.orderAnalysisSearchForm.bid ? this.orderAnalysisSearchForm.bid : null
      }
      this.orderAnalysisDetailList = []
      this.orderAnalysisDetailLoading = true
      getOrderJsbhAnalysisDetail(data).then(response => {
        this.orderAnalysisDetailList = response.data || []

        this.orderAnalysisDetailViewTitle = row.name + ' - 驳回订单列表 (共 ' + this.orderAnalysisDetailList.length + ' 单)'
        this.orderAnalysisDetailLoading = false
      }).catch(() => {
        this.orderAnalysisDetailLoading = false
      })
    },
    seeBhOrdersAnalysis() {
      this.orderAnalysisVisible = true

      let startTime = null
      let endTime = null
      if (this.orderAnalysisSearchForm.time !== null && this.orderAnalysisSearchForm.time.length === 2) {
        startTime = this.orderAnalysisSearchForm.time[0]
        endTime = this.orderAnalysisSearchForm.time[1]
      }
      const data = {
        start: startTime,
        end: endTime,
        content: this.orderAnalysisSearchForm.content ? this.orderAnalysisSearchForm.content : null,
        orderType: this.orderAnalysisSearchForm.orderType ? this.orderAnalysisSearchForm.orderType : null,
        bid: this.orderAnalysisSearchForm.bid ? this.orderAnalysisSearchForm.bid : null
      }
      this.orderAnalysisLoading = true
      getOrderJsbhAnalysis(data).then(response => {
        this.orderAnalysisData = response.data || {}
        this.initCharts()
        this.orderAnalysisLoading = false
      }).catch(() => {
        this.orderAnalysisLoading = false
      })
    },

    initCharts() {
      let circleDataArr = []
      let totalReasonCountList = []

      const globalTotalCount = this.orderAnalysisData.globalTotalCount
      // 对象属性遍历循环
      const totalReasonCount = this.orderAnalysisData.totalReasonCount
      const sortedReasonCount = Object.entries(totalReasonCount).sort((a, b) => b[1] - a[1]);
      for (const [key, value] of sortedReasonCount) {
        circleDataArr.push({
          name: key,
          y: value
        })
        totalReasonCountList.push({
          name: key,
          total: value,
          scaleTotal: Math.round(value / globalTotalCount * 10000) / 100
        })
      }
      this.orderAnalysisData.totalReasonCountList = totalReasonCountList
      let option1 = {
        lang: {
          printChart: '打印图表',
          downloadPNG: '下载JPEG 图片',
          downloadJPEG: '下载JPEG文档',
          downloadPDF: '下载PDF 图片',
          downloadSVG: '下载SVG 矢量图',
          contextButtonTitle: '下载图片'
        },
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: false,
        credits: {
          enabled: false
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.2f} %'
            }
          }
        },
        series: [{
          name: '占比',
          colorByPoint: true,
          data: circleDataArr
        }]
      }

      this.chartOption.totalReasonCount = option1


      let names = []
      let totalArr = []

      // 对象属性遍历循环
      const dealerTotalCount = this.orderAnalysisData.dealerTotalCount
      const sortedDealerTotal = Object.entries(dealerTotalCount).sort((a, b) => b[1] - a[1]);
      for (const [key, value] of sortedDealerTotal) {
        names.push(key)
        totalArr.push(value)
      }
      let option2 = {
        lang: {
          printChart: '打印图表',
          downloadPNG: '下载JPEG 图片',
          downloadJPEG: '下载JPEG文档',
          downloadPDF: '下载PDF 图片',
          downloadSVG: '下载SVG 矢量图',
          contextButtonTitle: '下载图片'
        },
        chart: {
          type: 'column'
        },
        title: {
          text: '经销商驳回订单总数统计'
        },
        xAxis: {
          categories: [...names]
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          column: {
            borderRadius: '2px'
          }
        },
        series: [{
          name: '驳回总数',
          data: [...totalArr]
        }]
      }

      this.chartOption.dealerTotalCount = option2

      
      let dealerNames = []
      let seriesData = []

      for (const key in totalReasonCount) {
        seriesData.push({ name: key, data: [] })
      }

      // 对象属性遍历循环
      const dealerReasonCount = this.orderAnalysisData.dealerReasonCount
      for (const [key, value] of sortedDealerTotal) {
        dealerNames.push(key)

        const reasons = dealerReasonCount[key]
        for (const item of seriesData) {
          let data = seriesData.find(r => r.name === item.name).data || []
          data.push(reasons[item.name] || 0)
          seriesData.find(r => r.name === item.name).data = data
        }
      }
      let option3 = {
        lang: {
          printChart: '打印图表',
          downloadPNG: '下载JPEG 图片',
          downloadJPEG: '下载JPEG文档',
          downloadPDF: '下载PDF 图片',
          downloadSVG: '下载SVG 矢量图',
          contextButtonTitle: '下载图片'
        },
        chart: {
          type: 'column'
        },
        title: {
          text: '经销商驳回订单原因分组统计'
        },
        xAxis: {
          categories: [...names]
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          // column: {
          //   stacking: 'normal',
          //   dataLabels: {
          //     enabled: true
          //   }
          // }
        },
        series: [...seriesData]
      }

      this.chartOption.dealerReasonCount = option3
    },

    exportExcel(searchForm = {}) {
      this.$message({
        message: '数据正在导出，请稍候'
      })

      let startTime = null
      let endTime = null
      if (searchForm.time !== null && searchForm.time.length === 2) {
        startTime = searchForm.time[0]
        endTime = searchForm.time[1]
      }
      const data = {
        start: startTime,
        end: endTime,
        content: searchForm.content ? searchForm.content : null,
        orderType: searchForm.orderType ? searchForm.orderType : null,
        bid: searchForm.bid ? searchForm.bid : null
      }
      exportOrderJsbh(data).then(response => {
        const _this = this
        let xhr = new XMLHttpRequest()
        xhr.open('GET', response.data.dPath, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          if (this.status === 200) {
            let blob = this.response
            let a = document.createElement('a')
            a.download = response.data.dName + '.' + response.data.dType
            a.href = window.URL.createObjectURL(blob)
            a.target = '_blank'
            a.click()
            const h = _this.$createElement
            _this.$msgbox({
              title: '下载提示',
              message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                h('a',
                  { attrs: {
                    href: window.URL.createObjectURL(blob),
                    target: '_blank',
                    download: `${response.data.dName}.${response.data.dType}`,
                    style: 'color: #409EFF;text-decoration:underline;'
                  }}, `点击这里`),
                h('span', null, `重新下载。`)
              ]),
              showCancelButton: false,
              confirmButtonText: '关闭',
              beforeClose: (action, instance, done) => {
                done()
              }
            }).then(action => {
            })
          }
        }
        xhr.send()
      })
    },

    exportAllExcel() {
      this.$message({
        message: '数据正在导出，请稍候'
      })
      exportOrderJsbh().then(response => {
        const _this = this
        let xhr = new XMLHttpRequest()
        xhr.open('GET', response.data.dPath, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          if (this.status === 200) {
            let blob = this.response
            let a = document.createElement('a')
            a.download = response.data.dName + '.' + response.data.dType
            a.href = window.URL.createObjectURL(blob)
            a.target = '_blank'
            a.click()
            const h = _this.$createElement
            _this.$msgbox({
              title: '下载提示',
              message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                h('a',
                  { attrs: {
                    href: window.URL.createObjectURL(blob),
                    target: '_blank',
                    download: `${response.data.dName}.${response.data.dType}`,
                    style: 'color: #409EFF;text-decoration:underline;'
                  }}, `点击这里`),
                h('span', null, `重新下载。`)
              ]),
              showCancelButton: false,
              confirmButtonText: '关闭',
              beforeClose: (action, instance, done) => {
                done()
              }
            }).then(action => {
            })
          }
        }
        xhr.send()
      })
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/order/' + row.order_id })
    },
    bhRsonList() {
      getBhRsonList().then(response => {
        this.rsonList = response.data || []
      }).catch(() => {})
    },
    assess(row) {
      this.editRules.content[0].required = false
      this.editForm.orderid = row.order_id
      this.editForm.ordername = row.order_num + ' / ' + row.address
      this.editForm.content = ''
      this.editForm.files = []
      this.editForm.imgids = []
      this.editVisible = true
      this.bhRsonList()
    },
    turn(formName) {
      this.editRules.content[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubAssessOrder(0)
        } else {
          return false
        }
      })
    },
    subEdit(formName) {
      this.editRules.content[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubAssessOrder(1)
        } else {
          return false
        }
      })
    },
    SubAssessOrder(ispass) {
      if (!this.editloading) {
        this.editloading = true
        const data = {
          userid: this.user.dUserid,
          orderid: this.editForm.orderid,
          reason: Array.isArray(this.editForm.content) ? this.editForm.content.join(';') : this.editForm.content,
          ispass: ispass,
          fileStr: this.editForm.files.join(','),
          imgStr: this.editForm.imgids.join(',')
        }
        assessOrder(data).then(response => {
          let msg = '技术评估已通过'
          if (ispass === 0) {
            msg = '订单已驳回'
          }
          this.$message({
            message: msg,
            type: 'success'
          })
          this.editloading = false
          this.editVisible = false
          this.getData()
        }).catch(() => {
          this.editloading = false
        })
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.jspg-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
